import { useMemo } from 'react'
import { useReselector } from '@/utils/sharedHooks'
import { Expense } from '@/actions/reportActions'

import { Progress, Separator, Card, Text, CardColors } from '@/ui'
import { TypographyStyles } from '@/styles'

import { orderBy } from 'lodash'

import CurrencyFormatLabel from '@/shared/CurrencyFormatLabel'
import { getTransactionCategorySelector } from '@/features/reports/reports.selectors'

// TODO: Migrate to V2
import { Loader } from 'semantic-ui-react'

const ExpensesLineItem = ({ expense }: { expense: Expense }) => {
  const selectedCategory = useReselector(
    getTransactionCategorySelector,
    expense.transactionCategoryId
  )

  return (
    <div className="expensesLineItem flex flex-wrap sm:grid sm:grid-cols-12 sm:items-center gap-y-2 mb-4">
      <Text variant={TypographyStyles.BODY_MD} className="sm:col-span-5">
        {selectedCategory?.name}
      </Text>
      <div className="sm:col-span-3">
        <CurrencyFormatLabel value={expense.sum} />
      </div>
      <div className="sm:col-span-4">
        <Progress
          value={Math.trunc(Number(expense.percentage) * 100)}
          size="large"
        />
      </div>
    </div>
  )
}

export const BookkeepingReportTopExpensesCard = ({
  loading,
  expensesObject,
}: {
  loading: boolean
  expensesObject: { expenses: Expense[]; sum: number }
}) => {
  const expenses = useMemo(
    () => orderBy(expensesObject.expenses, 'percentage', 'desc'),
    [expensesObject.expenses]
  )

  return (
    <Card color={CardColors.LEVEL_1} className="min-h-[300px]">
      <Text variant={TypographyStyles.H2}>Top Expenses This Month</Text>
      <Separator />
      {!loading && (
        <div className="flex flex-col gap-2 mt-4">
          {expenses.length > 0 &&
            expenses
              ?.slice(0, 5)
              .map((expense) => (
                <ExpensesLineItem
                  key={expense.transactionCategoryId}
                  expense={expense}
                />
              ))}
          {expenses.length === 0 && (
            <Text variant={TypographyStyles.BODY_MD}>
              No Expenses for the month!
            </Text>
          )}
        </div>
      )}

      {loading && <Loader inline active />}
    </Card>
  )
}
